module.exports = __webpack_public_path__ + "static/media/round14.fe203518.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/round14.png
// module id = 1165
// module chunks = 0